import {AbstractVisualFeature} from '#core/application/modules/visual-feature.js';
import {BasePalette} from '#core/application/modules/base-palette.js';

import {HomePage} from '../home-page.js';

import {homePageAvantgardeFactory} from './home-page-avantgarde.factory.js';

import SCHEMA from './home-page-avantgarde.schema.yaml';
import PALETTE_SCHEMA from './home-page-avantgarde.palette-schema.yaml';

class HomePageAvantgardeFeature extends AbstractVisualFeature {
    get enabled() {
        return BasePalette.isAvantgarde();
    }

    get name() {
        return 'HomePageAvantgarde';
    }

    get configSchema() {
        return SCHEMA;
    }

    get paletteSchema() {
        return PALETTE_SCHEMA;
    }

    getSerializableVisualConfig(PALETTE) {
        return homePageAvantgardeFactory(PALETTE);
    }
}

new HomePageAvantgardeFeature(HomePage);
